import React from 'react';
import { PricingCard } from './PricingCard';
export function FinalCTA() {
  return <div className="max-w-3xl mx-auto" data-id="element-53">
      <PricingCard idAttr="pricing-bottom" data-id="element-54" />
    </div>;
}